// Haptic feedback helpers. Uses the Vibration API, which works on Android browsers.
// iOS Safari doesn't support it, so these calls quietly do nothing there.

const canVibrate = () =>
  typeof navigator !== "undefined" &&
  typeof navigator.vibrate === "function" &&
  !(
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );

const vibrate = (pattern) => {
  if (!canVibrate()) return;
  try {
    navigator.vibrate(pattern);
  } catch {
    // ignore: haptics are a nice-to-have, never block the form
  }
};

// One short buzz
export const hapticSuccess = () => vibrate(50);

// Two quick buzzes
export const hapticError = () => vibrate([60, 60, 60]);